import classNames from "classnames";
import React from "react";

import strings from "../../utils/strings";
import icons from "../../utils/svgProvider";
import "./SubscriptionHighlight.scss";

interface SubscriptionHighlightPropsI {
	isInfoModal?: boolean;
}

const SubscriptionHighlight = (props: SubscriptionHighlightPropsI) => {
	return (
		<div>
			<div
				className={classNames({
					"addtocart-subscription-highlight": true,
					"info-modal": props.isInfoModal,
				})}
			>
				<div className="addtocart-subscription-highlight-title">
					<span className="addtocart-subscription-highlight-title-text">
						{strings["addtocartpopup.subscription.highlightThisIsFlex"]}
					</span>
					<span className="addtocart-subscription-highlight-title-logo">
						{icons.flexLogo}
					</span>
				</div>

				<div className="addtocart-subscription-highlight-points-wrapper">
					<div className="addtocart-subscription-highlight-point">
						<span className="addtocart-subscription-highlight-point-logo">
							{icons.flexPointPayToday}
						</span>
						<span className="addtocart-subscription-highlight-point-text">
							{strings["addtocartpopup.subscription.highlightPayToday"]}
						</span>
					</div>

					<div className="addtocart-subscription-highlight-point">
						<span className="addtocart-subscription-highlight-point-logo">
							{icons.flexPointFreeReturn}
						</span>
						<span className="addtocart-subscription-highlight-point-text">
							{strings["addtocartpopup.subscription.highlightFreeReturn"]}
						</span>
					</div>

					<div className="addtocart-subscription-highlight-point">
						<span className="addtocart-subscription-highlight-point-logo">
							{icons.flexPointReplaceAfter}
						</span>
						<span className="addtocart-subscription-highlight-point-text">
							{strings["addtocartpopup.subscription.highlightReplaceAfter"]}
						</span>
					</div>

					<div className="addtocart-subscription-highlight-point">
						<span className="addtocart-subscription-highlight-point-logo">
							{icons.flexPointNewOwner}
						</span>
						<span className="addtocart-subscription-highlight-point-text">
							{strings["addtocartpopup.subscription.highlightNewOwner"]}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SubscriptionHighlight;
